const UNIT_WORDS = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า']
const PLACE_WORDS = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน']
const DIGIT_WORDS = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า']

const num2Word = (nums) => {
  let result = ''
  const len = nums.length
  const maxLen = 7

  if (len > maxLen) {
    const overflowIndex = len - maxLen + 1
    return `${num2Word(nums.slice(0, overflowIndex))}ล้าน${num2Word(nums.slice(overflowIndex))}`
  }

  for (let i = 0; i < len; i++) {
    const digit = nums[i]
    if (digit > 0) {
      result += UNIT_WORDS[digit] + PLACE_WORDS[len - i - 1]
    }
  }

  return result
}

const grammarFix = (str) => str
  .replace(/หนึ่งสิบ/g, 'สิบ')
  .replace(/สองสิบ/g, 'ยี่สิบ')
  .replace(/สิบหนึ่ง/g, 'สิบเอ็ด')

const numberToText = (num) => {
  if (num === null || num === undefined || typeof num === 'boolean') return 'ศูนย์'

  const numStr = String(num).replace(/,/g, '')
  const parsedNum = Number(numStr)

  if (Number.isNaN(parsedNum) || parsedNum < 0 || parsedNum > Number.MAX_SAFE_INTEGER) {
    return 'ศูนย์'
  }

  const [intStr, decStr] = numStr.split('.')

  const intPart = grammarFix(num2Word(Array.from(intStr).map(Number))) || 'ศูนย์'

  if (!decStr) return intPart

  const decPart = Array.from(decStr).map((d) => DIGIT_WORDS[Number(d)]).join('')

  return `${intPart}จุด${decPart}`
}

export default numberToText
